import { Box, Text } from '@chakra-ui/react'

import type { FeaturedFeedback } from '../types'
import FeedbackStar from './FeedbackStar'

const FeaturedFeedbackBox: React.FC<{
  feedback: FeaturedFeedback
  showFeedbackStar?: {
    featuredFeedbackCount: number
  } | null
}> = ({ feedback, showFeedbackStar }) => (
  <Box
    position="relative"
    rounded="md"
    border="2px solid"
    borderColor="border"
    my={2}
    p={4}
    minH="100px"
    bg="bg"
    zIndex={0}
  >
    <Box mt={3} ml={3}>
      <Text color="dark" fontWeight={600} mb={3}>
        {' '}
        {/* TODO: Map "dark" to a semantic token if possible */}
        {feedback.comment}
      </Text>
      <Text fontWeight={600} color="fg.subtle">
        {feedback.type === 'self'
          ? 'Self'
          : feedback.type === 'old-audit' || feedback.type === 'audit'
            ? 'Tutor'
            : 'Learner'}{' '}
        · {feedback.date.toRelative({ style: 'narrow' })}
      </Text>
    </Box>
    {showFeedbackStar != null ? (
      <Box position="absolute" top={0} right={2} zIndex={1}>
        <FeedbackStar
          feedbackId={feedback.id}
          type={feedback.type}
          isFeatured
          featuredCount={showFeedbackStar.featuredFeedbackCount}
          isEmpty={feedback.comment === ''}
          auditRubricQuestionSlug={feedback.auditRubricQuestionSlug}
        />
      </Box>
    ) : null}
    <Box position="absolute" top={10} zIndex={-1}>
      <Text fontSize="100px" fontWeight="bold" color="yellow.solid">
        “
      </Text>
    </Box>
  </Box>
)

export default FeaturedFeedbackBox
